// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ApolloClient__Utils from "../../../../ApolloClient__Utils.bs.js";
import * as ApolloClient__Core_Types from "../../core/ApolloClient__Core_Types.bs.js";
import * as ApolloClient__Link_Core_Types from "../../link/core/ApolloClient__Link_Core_Types.bs.js";
import * as ApolloClient__Core_NetworkStatus from "../../core/ApolloClient__Core_NetworkStatus.bs.js";
import * as ApolloClient__Errors_ApolloError from "../../errors/ApolloClient__Errors_ApolloError.bs.js";
import * as ApolloClient__Core_WatchQueryOptions from "../../core/ApolloClient__Core_WatchQueryOptions.bs.js";

var Js_ = {};

function toJs(t, mapJsVariables, safeParse, serializeVariables) {
  var tmp = {
    variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables))
  };
  if (t.query !== undefined) {
    tmp.query = Caml_option.valFromOption(t.query);
  }
  if (t.displayName !== undefined) {
    tmp.displayName = t.displayName;
  }
  if (t.skip !== undefined) {
    tmp.skip = t.skip;
  }
  var tmp$1 = Belt_Option.map(t.onCompleted, (function (onCompleted, jsData) {
          Curry._1(onCompleted, Curry._1(safeParse, jsData));
        }));
  if (tmp$1 !== undefined) {
    tmp.onCompleted = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_Option.map(t.onError, (function (onError) {
          return function (jsApolloError) {
            Curry._1(onError, ApolloClient__Errors_ApolloError.fromJs(jsApolloError));
          };
        }));
  if (tmp$2 !== undefined) {
    tmp.onError = Caml_option.valFromOption(tmp$2);
  }
  if (t.client !== undefined) {
    tmp.client = Caml_option.valFromOption(t.client);
  }
  if (t.context !== undefined) {
    tmp.context = Caml_option.valFromOption(t.context);
  }
  var tmp$3 = Belt_Option.map(t.errorPolicy, ApolloClient__Core_WatchQueryOptions.ErrorPolicy.toJs);
  if (tmp$3 !== undefined) {
    tmp.errorPolicy = tmp$3;
  }
  var tmp$4 = Belt_Option.map(t.fetchPolicy, ApolloClient__Core_WatchQueryOptions.WatchQueryFetchPolicy.toJs);
  if (tmp$4 !== undefined) {
    tmp.fetchPolicy = tmp$4;
  }
  var tmp$5 = Belt_Option.map(t.nextFetchPolicy, ApolloClient__Core_WatchQueryOptions.WatchQueryFetchPolicy.toJs);
  if (tmp$5 !== undefined) {
    tmp.nextFetchPolicy = tmp$5;
  }
  if (t.notifyOnNetworkStatusChange !== undefined) {
    tmp.notifyOnNetworkStatusChange = t.notifyOnNetworkStatusChange;
  }
  if (t.partialRefetch !== undefined) {
    tmp.partialRefetch = t.partialRefetch;
  }
  if (t.pollInterval !== undefined) {
    tmp.pollInterval = t.pollInterval;
  }
  if (t.ssr !== undefined) {
    tmp.ssr = t.ssr;
  }
  return tmp;
}

var QueryHookOptions = {
  Js_: Js_,
  toJs: toJs
};

var Js_$1 = {};

function toJs$1(t, safeParse, serializeVariables) {
  var tmp = {};
  if (t.query !== undefined) {
    tmp.query = Caml_option.valFromOption(t.query);
  }
  if (t.displayName !== undefined) {
    tmp.displayName = t.displayName;
  }
  var tmp$1 = Belt_Option.map(t.onCompleted, (function (onCompleted, jsData) {
          Curry._1(onCompleted, Curry._1(safeParse, jsData));
        }));
  if (tmp$1 !== undefined) {
    tmp.onCompleted = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_Option.map(t.onError, (function (onError) {
          return function (jsApolloError) {
            Curry._1(onError, ApolloClient__Errors_ApolloError.fromJs(jsApolloError));
          };
        }));
  if (tmp$2 !== undefined) {
    tmp.onError = Caml_option.valFromOption(tmp$2);
  }
  if (t.client !== undefined) {
    tmp.client = Caml_option.valFromOption(t.client);
  }
  if (t.context !== undefined) {
    tmp.context = Caml_option.valFromOption(t.context);
  }
  var tmp$3 = Belt_Option.map(t.errorPolicy, ApolloClient__Core_WatchQueryOptions.ErrorPolicy.toJs);
  if (tmp$3 !== undefined) {
    tmp.errorPolicy = tmp$3;
  }
  var tmp$4 = Belt_Option.map(t.fetchPolicy, ApolloClient__Core_WatchQueryOptions.WatchQueryFetchPolicy.toJs);
  if (tmp$4 !== undefined) {
    tmp.fetchPolicy = tmp$4;
  }
  if (t.notifyOnNetworkStatusChange !== undefined) {
    tmp.notifyOnNetworkStatusChange = t.notifyOnNetworkStatusChange;
  }
  if (t.partialRefetch !== undefined) {
    tmp.partialRefetch = t.partialRefetch;
  }
  if (t.pollInterval !== undefined) {
    tmp.pollInterval = t.pollInterval;
  }
  if (t.ssr !== undefined) {
    tmp.ssr = t.ssr;
  }
  var tmp$5 = Belt_Option.map(t.variables, serializeVariables);
  if (tmp$5 !== undefined) {
    tmp.variables = Caml_option.valFromOption(tmp$5);
  }
  return tmp;
}

var LazyQueryHookOptions = {
  Js_: Js_$1,
  toJs: toJs$1
};

var Js_$2 = {};

var QueryLazyOptions = {
  Js_: Js_$2
};

var Js_$3 = {};

function fromJs(js, safeParse, serialize, serializeVariables) {
  var match = ApolloClient__Utils.safeParseAndLiftToCommonResultProps(js.data, undefined, Belt_Option.map(js.error, ApolloClient__Errors_ApolloError.fromJs), safeParse);
  var previousData = Belt_Option.map(js.previousData, safeParse);
  var fetchMore = function (context, mapJsVariablesOpt, variables, updateQuery, param) {
    var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
          return prim;
        });
    var parseErrorDuringCall = {
      contents: undefined
    };
    var tmp = {};
    var tmp$1 = Belt_Option.map(variables, (function (v) {
            return Curry._1(mapJsVariables, Curry._1(serializeVariables, v));
          }));
    if (tmp$1 !== undefined) {
      tmp.variables = Caml_option.valFromOption(tmp$1);
    }
    if (context !== undefined) {
      tmp.context = Caml_option.valFromOption(context);
    }
    var tmp$2 = Belt_Option.map(updateQuery, (function (updateQuery) {
            return function (previousResult, jsFetchMoreOptions) {
              var match = Curry._1(safeParse, previousResult);
              var match$1 = Belt_Option.map(jsFetchMoreOptions.fetchMoreResult, safeParse);
              if (match.TAG === /* Ok */0) {
                var previousResult$1 = match._0;
                if (match$1 === undefined) {
                  return Curry._1(serialize, Curry._2(updateQuery, previousResult$1, {
                                  fetchMoreResult: undefined,
                                  variables: jsFetchMoreOptions.variables
                                }));
                }
                if (match$1.TAG === /* Ok */0) {
                  return Curry._1(serialize, Curry._2(updateQuery, previousResult$1, {
                                  fetchMoreResult: Caml_option.some(match$1._0),
                                  variables: jsFetchMoreOptions.variables
                                }));
                }
                parseErrorDuringCall.contents = {
                  TAG: /* Error */1,
                  _0: match$1._0
                };
                return previousResult;
              }
              parseErrorDuringCall.contents = {
                TAG: /* Error */1,
                _0: match._0
              };
              return previousResult;
            };
          }));
    if (tmp$2 !== undefined) {
      tmp.updateQuery = Caml_option.valFromOption(tmp$2);
    }
    var __x = js.fetchMore(tmp);
    var __x$1 = Js_promise.then_((function (jsApolloQueryResult) {
            var match = parseErrorDuringCall.contents;
            var tmp;
            tmp = match !== undefined && match.TAG !== /* Ok */0 ? ({
                  TAG: /* Error */1,
                  _0: ApolloClient__Errors_ApolloError.make(undefined, {
                        TAG: /* ParseError */3,
                        _0: match._0
                      }, undefined, undefined, undefined)
                }) : ApolloClient__Core_Types.ApolloQueryResult.toResult(ApolloClient__Core_Types.ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse));
            return Promise.resolve(tmp);
          }), __x);
    return Js_promise.$$catch((function (error) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: ApolloClient__Errors_ApolloError.make(undefined, {
                                    TAG: /* FetchFailure */0,
                                    _0: ApolloClient__Utils.ensureError(error)
                                  }, undefined, undefined, undefined)
                            });
                }), __x$1);
  };
  var refetch = function (mapJsVariablesOpt, variables, param) {
    var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
          return prim;
        });
    var __x = js.refetch(Belt_Option.map(variables, (function (v) {
                return Curry._1(mapJsVariables, Curry._1(serializeVariables, v));
              })));
    var __x$1 = Js_promise.then_((function (jsApolloQueryResult) {
            return Promise.resolve(ApolloClient__Core_Types.ApolloQueryResult.toResult(ApolloClient__Core_Types.ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse)));
          }), __x);
    return Js_promise.$$catch((function (error) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: ApolloClient__Errors_ApolloError.make(undefined, {
                                    TAG: /* FetchFailure */0,
                                    _0: ApolloClient__Utils.ensureError(error)
                                  }, undefined, undefined, undefined)
                            });
                }), __x$1);
  };
  var startPolling = function (pollInterval) {
    js.startPolling(pollInterval);
  };
  var stopPolling = function (param) {
    js.stopPolling();
  };
  var subscribeToMore = function (Operation, updateQuery, onError, context, variables) {
    var subscriptionSafeParse = function (param) {
      return ApolloClient__Utils.safeParse(Operation.parse, param);
    };
    return js.subscribeToMore(ApolloClient__Core_WatchQueryOptions.SubscribeToMoreOptions.toJs({
                    document: Operation.query,
                    variables: variables,
                    updateQuery: updateQuery,
                    onError: Belt_Option.map(onError, (function (onError, error) {
                            Curry._1(onError, {
                                  TAG: /* SubscriptionError */1,
                                  _0: error
                                });
                          })),
                    context: context
                  }, (function (parseError) {
                      if (onError !== undefined) {
                        return Curry._1(onError, {
                                    TAG: /* ParseError */0,
                                    _0: parseError
                                  });
                      }
                      
                    }), safeParse, serialize, subscriptionSafeParse));
  };
  var updateQuery = function (updateQueryFn) {
    js.updateQuery(function (jsPreviousData, options) {
          return Curry._1(serialize, Curry._2(updateQueryFn, Curry._1(safeParse, jsPreviousData), options));
        });
  };
  return {
          called: js.called,
          client: js.client,
          data: match[0],
          previousData: previousData,
          error: match[1],
          loading: js.loading,
          networkStatus: ApolloClient__Core_NetworkStatus.NetworkStatus.fromJs(js.networkStatus),
          fetchMore: fetchMore,
          refetch: refetch,
          startPolling: startPolling,
          stopPolling: stopPolling,
          subscribeToMore: subscribeToMore,
          updateQuery: updateQuery
        };
}

var QueryResult = {
  Js_: Js_$3,
  fromJs: fromJs
};

var Js_$4 = {};

function fromJs$1(js) {
  return {
          loading: js.loading,
          networkStatus: ApolloClient__Core_NetworkStatus.NetworkStatus.fromJs(js.networkStatus),
          called: js.called
        };
}

var UnexecutedLazyResult = {
  Js_: Js_$4,
  fromJs: fromJs$1
};

function unexecutedLazyResult(v) {
  return v;
}

function queryResult(v) {
  return v;
}

function classify(v) {
  if ((function (value) { return "client" in value})(v)) {
    return {
            TAG: /* QueryResult */1,
            _0: v
          };
  } else {
    return {
            TAG: /* UnexecutedLazyResult */0,
            _0: v
          };
  }
}

var Union = {
  unexecutedLazyResult: unexecutedLazyResult,
  queryResult: queryResult,
  classify: classify
};

var Js_$5 = {
  Union: Union
};

function fromJs$2(js, safeParse, serialize, serializeVariables) {
  var v = classify(js);
  if (v.TAG === /* UnexecutedLazyResult */0) {
    return {
            TAG: /* Unexecuted */1,
            _0: fromJs$1(v._0)
          };
  } else {
    return {
            TAG: /* Executed */0,
            _0: fromJs(v._0, safeParse, serialize, serializeVariables)
          };
  }
}

var LazyQueryResult = {
  Js_: Js_$5,
  fromJs: fromJs$2
};

var Js_$6 = {};

function fromJs$3(param, safeParse, serialize, serializeVariables) {
  var jsExecuteQuery = param[0];
  return [
          (function (context, mapJsVariablesOpt, variables) {
              var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
                    return prim;
                  });
              return Js_promise.then_((function (jsResult) {
                            return Promise.resolve(fromJs(jsResult, safeParse, serialize, serializeVariables));
                          }), Curry._1(jsExecuteQuery, {
                              variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, variables)),
                              context: context
                            }));
            }),
          fromJs$2(param[1], safeParse, serialize, serializeVariables)
        ];
}

var QueryTuple = {
  Js_: Js_$6,
  fromJs: fromJs$3
};

var Js_$7 = {};

function fromJs$4(param, mapJsVariables, safeParse, serialize, serializeVariables, variables) {
  var jsExecuteQuery = param[0];
  return [
          (function (context, param) {
              return Js_promise.then_((function (jsResult) {
                            return Promise.resolve(fromJs(jsResult, safeParse, serialize, serializeVariables));
                          }), Curry._1(jsExecuteQuery, {
                              variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, variables)),
                              context: context
                            }));
            }),
          fromJs$2(param[1], safeParse, serialize, serializeVariables)
        ];
}

var QueryTuple__noVariables = {
  Js_: Js_$7,
  fromJs: fromJs$4
};

var Js_$8 = {};

var BaseMutationOptions = {
  Js_: Js_$8
};

var Js_$9 = {};

function toJs$2(t, mapJsVariables, safeParse, serialize, serializeVariables) {
  var func = ApolloClient__Core_WatchQueryOptions.MutationUpdaterFn.toJs;
  var tmp = {};
  if (t.mutation !== undefined) {
    tmp.mutation = Caml_option.valFromOption(t.mutation);
  }
  if (t.awaitRefetchQueries !== undefined) {
    tmp.awaitRefetchQueries = t.awaitRefetchQueries;
  }
  if (t.client !== undefined) {
    tmp.client = Caml_option.valFromOption(t.client);
  }
  if (t.context !== undefined) {
    tmp.context = Caml_option.valFromOption(t.context);
  }
  var tmp$1 = Belt_Option.map(t.errorPolicy, ApolloClient__Core_WatchQueryOptions.ErrorPolicy.toJs);
  if (tmp$1 !== undefined) {
    tmp.errorPolicy = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_Option.map(t.fetchPolicy, ApolloClient__Core_WatchQueryOptions.FetchPolicy__noCacheExtracted.toJs);
  if (tmp$2 !== undefined) {
    tmp.fetchPolicy = Caml_option.valFromOption(tmp$2);
  }
  if (t.ignoreResults !== undefined) {
    tmp.ignoreResults = t.ignoreResults;
  }
  if (t.notifyOnNetworkStatusChange !== undefined) {
    tmp.notifyOnNetworkStatusChange = t.notifyOnNetworkStatusChange;
  }
  var tmp$3 = Belt_Option.map(t.onError, (function (onError) {
          return function (jsApolloError) {
            Curry._1(onError, ApolloClient__Errors_ApolloError.fromJs(jsApolloError));
          };
        }));
  if (tmp$3 !== undefined) {
    tmp.onError = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Belt_Option.map(t.onCompleted, (function (onCompleted, jsData) {
          Curry._1(onCompleted, Curry._1(safeParse, jsData));
        }));
  if (tmp$4 !== undefined) {
    tmp.onCompleted = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = Belt_Option.map(t.optimisticResponse, (function (optimisticResponse, variables) {
          return Curry._1(serialize, Curry._1(optimisticResponse, variables));
        }));
  if (tmp$5 !== undefined) {
    tmp.optimisticResponse = Caml_option.valFromOption(tmp$5);
  }
  var tmp$6 = Belt_Option.map(t.refetchQueries, ApolloClient__Core_WatchQueryOptions.RefetchQueryDescription.toJs);
  if (tmp$6 !== undefined) {
    tmp.refetchQueries = Caml_option.valFromOption(tmp$6);
  }
  var tmp$7 = Belt_Option.map(t.update, (function (param) {
          return Curry._2(func, param, safeParse);
        }));
  if (tmp$7 !== undefined) {
    tmp.update = Caml_option.valFromOption(tmp$7);
  }
  var tmp$8 = Belt_Option.map(t.variables, (function (v) {
          return Curry._1(mapJsVariables, Curry._1(serializeVariables, v));
        }));
  if (tmp$8 !== undefined) {
    tmp.variables = Caml_option.valFromOption(tmp$8);
  }
  return tmp;
}

var MutationHookOptions = {
  Js_: Js_$9,
  toJs: toJs$2
};

var Js_$10 = {};

function fromJs$5(js, safeParse) {
  var match = ApolloClient__Utils.safeParseAndLiftToCommonResultProps(Caml_option.nullable_to_opt(js.data), undefined, Belt_Option.map(js.error, ApolloClient__Errors_ApolloError.fromJs), safeParse);
  return {
          data: match[0],
          error: match[1],
          loading: js.loading,
          called: js.called,
          client: js.client,
          reset: js.reset
        };
}

var MutationResult = {
  Js_: Js_$10,
  fromJs: fromJs$5
};

var Js_$11 = {};

function toJs$3(t, mapJsVariables, safeParse, serialize, serializeVariables) {
  var func = ApolloClient__Core_WatchQueryOptions.MutationUpdaterFn.toJs;
  return {
          variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables)),
          optimisticResponse: Belt_Option.map(t.optimisticResponse, (function (optimisticResponse) {
                  return function (variables) {
                    return Curry._1(serialize, Curry._1(optimisticResponse, variables));
                  };
                })),
          refetchQueries: Belt_Option.map(t.refetchQueries, ApolloClient__Core_WatchQueryOptions.RefetchQueryDescription.toJs),
          awaitRefetchQueries: t.awaitRefetchQueries,
          update: Belt_Option.map(t.update, (function (param) {
                  return Curry._2(func, param, safeParse);
                })),
          context: t.context,
          fetchPolicy: Belt_Option.map(t.fetchPolicy, ApolloClient__Core_WatchQueryOptions.WatchQueryFetchPolicy.toJs)
        };
}

var MutationFunctionOptions = {
  Js_: Js_$11,
  toJs: toJs$3
};

var Js_$12 = {};

function fromJs$6(param, safeParse, serialize, serializeVariables) {
  var jsMutationFn = param[0];
  var mutationFn = function (awaitRefetchQueries, context, fetchPolicy, mapJsVariablesOpt, optimisticResponse, refetchQueries, update, variables) {
    var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
          return prim;
        });
    var __x = Curry._1(jsMutationFn, toJs$3({
              variables: variables,
              optimisticResponse: optimisticResponse,
              refetchQueries: refetchQueries,
              awaitRefetchQueries: awaitRefetchQueries,
              update: update,
              context: context,
              fetchPolicy: fetchPolicy
            }, mapJsVariables, safeParse, serialize, serializeVariables));
    var __x$1 = Js_promise.then_((function (jsFetchResult) {
            return Promise.resolve(ApolloClient__Link_Core_Types.FetchResult.toResult(ApolloClient__Link_Core_Types.FetchResult.fromJs(jsFetchResult, safeParse)));
          }), __x);
    return Js_promise.$$catch((function (error) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: ApolloClient__Errors_ApolloError.make(undefined, {
                                    TAG: /* FetchFailure */0,
                                    _0: ApolloClient__Utils.ensureError(error)
                                  }, undefined, undefined, undefined)
                            });
                }), __x$1);
  };
  return [
          mutationFn,
          fromJs$5(param[1], safeParse)
        ];
}

var MutationTuple = {
  Js_: Js_$12,
  fromJs: fromJs$6
};

var Js_$13 = {};

function fromJs$7(param, mapJsVariables, safeParse, serialize, serializeVariables, variables) {
  var jsMutationFn = param[0];
  var mutationFn = function (optimisticResponse, refetchQueries, awaitRefetchQueries, update, context, fetchPolicy, param) {
    var __x = Curry._1(jsMutationFn, toJs$3({
              variables: variables,
              optimisticResponse: optimisticResponse,
              refetchQueries: refetchQueries,
              awaitRefetchQueries: awaitRefetchQueries,
              update: update,
              context: context,
              fetchPolicy: fetchPolicy
            }, mapJsVariables, safeParse, serialize, serializeVariables));
    var __x$1 = Js_promise.then_((function (jsFetchResult) {
            return Promise.resolve(ApolloClient__Link_Core_Types.FetchResult.toResult(ApolloClient__Link_Core_Types.FetchResult.fromJs(jsFetchResult, safeParse)));
          }), __x);
    return Js_promise.$$catch((function (error) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: ApolloClient__Errors_ApolloError.make(undefined, {
                                    TAG: /* FetchFailure */0,
                                    _0: ApolloClient__Utils.ensureError(error)
                                  }, undefined, undefined, undefined)
                            });
                }), __x$1);
  };
  return [
          mutationFn,
          fromJs$5(param[1], safeParse)
        ];
}

var MutationTuple__noVariables = {
  Js_: Js_$13,
  fromJs: fromJs$7
};

var Js_$14 = {};

function fromJs$8(js, safeParse) {
  var match = ApolloClient__Utils.safeParseAndLiftToCommonResultProps(js.data, undefined, Belt_Option.map(js.error, ApolloClient__Errors_ApolloError.fromJs), safeParse);
  return {
          loading: js.loading,
          data: match[0],
          error: match[1]
        };
}

var SubscriptionResult = {
  Js_: Js_$14,
  fromJs: fromJs$8
};

var Js_$15 = {};

function fromJs$9(js, safeParse) {
  return {
          client: js.client,
          subscriptionData: fromJs$8(js.subscriptionData, safeParse)
        };
}

var OnSubscriptionDataOptions = {
  Js_: Js_$15,
  fromJs: fromJs$9
};

var Js_$16 = {};

function fromJs$10(js) {
  return {
          variables: js.variables,
          fetchPolicy: js.fetchPolicy,
          shouldResubscribe: js.shouldResubscribe,
          client: js.client,
          skip: js.skip,
          onSubscriptionData: js.onSubscriptionData,
          onSubscriptionComplete: js.onSubscriptionComplete
        };
}

var BaseSubscriptionOptions = {
  Js_: Js_$16,
  fromJs: fromJs$10
};

var Js_$17 = {};

function toJs$4(t, mapJsVariables, safeParse, serializeVariables) {
  var tmp = {
    variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables))
  };
  if (t.subscription !== undefined) {
    tmp.subscription = Caml_option.valFromOption(t.subscription);
  }
  if (t.fetchPolicy !== undefined) {
    tmp.fetchPolicy = Caml_option.valFromOption(t.fetchPolicy);
  }
  var tmp$1 = Belt_Option.map(t.shouldResubscribe, (function (shouldResubscribe) {
          return function (jsBaseSubscriptionOptions) {
            return Curry._1(shouldResubscribe, fromJs$10(jsBaseSubscriptionOptions));
          };
        }));
  if (tmp$1 !== undefined) {
    tmp.shouldResubscribe = Caml_option.valFromOption(tmp$1);
  }
  if (t.client !== undefined) {
    tmp.client = Caml_option.valFromOption(t.client);
  }
  if (t.skip !== undefined) {
    tmp.skip = t.skip;
  }
  var tmp$2 = Belt_Option.map(t.onSubscriptionData, (function (onSubscriptionData) {
          return function (jsOnSubscriptionDataOptions) {
            Curry._1(onSubscriptionData, fromJs$9(jsOnSubscriptionDataOptions, safeParse));
          };
        }));
  if (tmp$2 !== undefined) {
    tmp.onSubscriptionData = Caml_option.valFromOption(tmp$2);
  }
  if (t.onSubscriptionComplete !== undefined) {
    tmp.onSubscriptionComplete = Caml_option.valFromOption(t.onSubscriptionComplete);
  }
  return tmp;
}

var SubscriptionHookOptions = {
  Js_: Js_$17,
  toJs: toJs$4
};

var ApolloClient;

var ApolloError;

var ApolloQueryResult;

var ErrorPolicy;

var FetchPolicy;

var FetchPolicy__noCacheExtracted;

var FetchResult;

var Graphql;

var MutationUpdaterFn;

var NetworkStatus;

var RefetchQueryDescription;

var SubscribeToMoreOptions;

var Types;

var UpdateQueryFn;

var Utils;

var WatchQueryFetchPolicy;

export {
  ApolloClient ,
  ApolloError ,
  ApolloQueryResult ,
  ErrorPolicy ,
  FetchPolicy ,
  FetchPolicy__noCacheExtracted ,
  FetchResult ,
  Graphql ,
  MutationUpdaterFn ,
  NetworkStatus ,
  RefetchQueryDescription ,
  SubscribeToMoreOptions ,
  Types ,
  UpdateQueryFn ,
  Utils ,
  WatchQueryFetchPolicy ,
  QueryHookOptions ,
  LazyQueryHookOptions ,
  QueryLazyOptions ,
  QueryResult ,
  UnexecutedLazyResult ,
  LazyQueryResult ,
  QueryTuple ,
  QueryTuple__noVariables ,
  BaseMutationOptions ,
  MutationHookOptions ,
  MutationResult ,
  MutationFunctionOptions ,
  MutationTuple ,
  MutationTuple__noVariables ,
  SubscriptionResult ,
  OnSubscriptionDataOptions ,
  BaseSubscriptionOptions ,
  SubscriptionHookOptions ,
}
/* ApolloClient__Utils Not a pure module */
